(function($, duo, undefined) {

	"use strict";

	// classes:
	const LANGUAGE_WRAPPER_CLASS = 'js-language-wrapper';
	const LANGUAGE_BUTTON_CLASS = 'js-language-button';
	const LANGUAGE_CONTENTWRAPPER_CLASS = 'js-language-contentwrapper';

	/**
	 * @class LanguageSelect
	 * create a language dropdown from a list of language links
	 */
	class LanguageSelect {

		/**
		 * Creates an instance of LanguageSelect
		 * @param {string} listSelector css selector for the list of language links
		 * @param {string} defaultToggleText default text for the toggle button
		 * @param {boolean} allowKeyboardEscape allow closing via the ESC-key
		 */
		constructor({listSelector = '#site-header__desktop .block-language', defaultToggleText = Drupal.t('Language'), allowKeyboardEscape = true} = {}) {
			this.listSelector = listSelector;
			this.defaultToggleText = defaultToggleText;
			this.allowKeyboardEscape = allowKeyboardEscape;

			//create a unique reference for the language select block:
			this.languageSelectRef = 'langSelectRef-' + duo.Utils.uniqueId;
			$(this.listSelector).attr('data-langref', `${this.languageSelectRef}`);

			// setup:
			this._setup();

			// setup event handlers:
			this._setEventHandlers();
		} /* constructor */

		/**
		 * Setup HTML markup
		 */
		_setup() {
			const languageselect = this;

			// setup markup:
		 	$(document).find(`${languageselect.listSelector} > ul`).each(function(index, element) {
				const $languageList = $(element);

				// -> get the current language + set active class on li:
				let currentLanguageName = languageselect.defaultToggleText;
				const $currentLanguageElement = $languageList.find('a.is-active').first();
				if($currentLanguageElement.length > 0) {
					currentLanguageName = $currentLanguageElement.attr('hreflang');
					$currentLanguageElement.parent().addClass('active');
				}

				// -> create a unique ID:
				const id = 'languagelist-' + duo.Utils.uniqueId;

				// -> make a container block:
				$languageList.wrap(`<div class="${LANGUAGE_WRAPPER_CLASS}"></div>`);
				const $container = $languageList.parent();

				// -> wrap the content:
				$languageList.wrap(`<div id="${id}" aria-hidden="true" class="${LANGUAGE_CONTENTWRAPPER_CLASS}" data-role="languagelist-content">`);

				// -> create the toggle button:
				$container.prepend(`<button type="button" aria-expanded="false" aria-controls="${id}" class="${LANGUAGE_BUTTON_CLASS}" data-role="languagelist-button"><span class="lang-selected-abbr">${currentLanguageName}<span><span class="visually-hidden">${ Drupal.t('(click to select another language)') }</span></button>`);

				$('.block-language').addClass('js-loaded');

			});
		} /* _setup */

		/**
		 * Attach event listeners
		 */
		_setEventHandlers() {
			const languageselect = this;

			/* toggle button click */
			/* ******************* */

			// $(document).on(`click.${languageselect.languageSelectRef}`, `${languageselect.listSelector} .${LANGUAGE_BUTTON_CLASS}`, function(event) {
			// 	const $languageButton = $(this);

			// 	// toggle the language zone:
			// 	// -> get current language block:
			// 	const $languageItem = $languageButton.parents(`.${LANGUAGE_WRAPPER_CLASS}`);
			// 	// -> toggle:
			// 	languageselect._toggleItem($languageItem);

			// 	// toggle all other language selects:
			// 	$(document).find(`[data-langref]:not([data-langref="${languageselect.languageSelectRef}"])`).each(function(index, element) {
			// 		if($(element).find('.js-languageselect-open').length > 0) {
			// 			const $langWrapper = $(element).find(`.${LANGUAGE_WRAPPER_CLASS}`);
			// 			if($langWrapper.length > 0) {
			// 				languageselect._toggleItem($langWrapper, false);
			// 			}
			// 		}
			// 	});
			// });

			/* close via ESC-key */
			/* ***************** */

			if(languageselect.allowKeyboardEscape) {

				$(document).on(`keyup.${languageselect.languageSelectRef}`, function(e) {
					if(e.keyCode === 27) {
						const $elementToClose = $(document).find(`[data-langref="${languageselect.languageSelectRef}"]`);
						if($elementToClose.length > 0) {
							const $currentLangWrapper = $elementToClose.find(`.${LANGUAGE_WRAPPER_CLASS}.js-languageselect-open`);
							if($currentLangWrapper.length > 0) {
								languageselect._toggleItem($currentLangWrapper, false);
							}
						}
					}
				});
			
			}

			/* close via click outside */
			/* *********************** */

			$(document).on(`click.${languageselect.languageSelectRef} touchstart.${languageselect.languageSelectRef}`, function(event) {
				const target = $(event.target);
				if(target.closest(languageselect.listSelector).length <= 0) {
					const $elementToClose = $(document).find(`[data-langref="${languageselect.languageSelectRef}"]`);
					if($elementToClose.length > 0) {
						const $currentLangWrapper = $elementToClose.find(`.${LANGUAGE_WRAPPER_CLASS}.js-languageselect-open`);
						if($currentLangWrapper.length > 0) {
							languageselect._toggleItem($currentLangWrapper, false);
						}
					}
				}
			});

		} /* _setEventHandlers */

		/**
		 * Toggle item
		 */
		_toggleItem($languageItem, resultState) {
			let $languageButton;
			let $contentElement;

			if($languageItem.length > 0) {
				$languageButton = $languageItem.find(`.${LANGUAGE_BUTTON_CLASS}`);
				$contentElement = $languageItem.find(`.${LANGUAGE_CONTENTWRAPPER_CLASS}`);
			}

			// change the markup:
			if($languageItem.length > 0 && $languageButton.length > 0 && $contentElement.length > 0) {

				// -> get the current expanded-state:
				let state = $languageButton.attr('aria-expanded') === 'false' ? true : false;
				if(resultState !== undefined) {
					if(resultState === 'close') {
						state = false;
					} else if(resultState === 'open') {
						state = true;
					}
				}

				// -> set the expanded state on the button:
				$languageButton.attr('aria-expanded', state);

				// -> set aria-hidden state on the content:
				$contentElement.attr('aria-hidden', !state);

				// -> set open-class on the container-item:
				if(state) {
					$languageItem.addClass('js-languageselect-open');
				} else {
					$languageItem.removeClass('js-languageselect-open');
				}

			}
		} /* _toggleItem */

	} /* LanguageSelect */

	duo.LanguageSelect = LanguageSelect;

})(jQuery, window.duo = window.duo || {});
